import {userConstants} from '../constants/user.constants.js';

const initialState = {};

export const friends = (state = initialState, action) => {
  switch (action.type) {
    case userConstants.LOY3_GET_FRIENDS_SUCCESS:
      return Object.assign({}, state, {
        friends: action.payload,
      });
    case userConstants.LOY3_TRANSFER_POINTS_FAILURE:
      return Object.assign({}, state, {
      });
    case userConstants.LOY3_INVITE_FRIEND:
      return {
        ...state,
        inviteUser: action.loy3InviteFriend
      };
    default:
      return state
  }
};
